<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const OrdersRepository = Repositories.get('orders');
import scrollMixin from '@/mixins/scrollWheelMixin';
import OrderItemsWoitemsSubList from './order-items-woitems-sub-list.vue';

export default {
  props: {
    orderItemsList: Array,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  mixins: [scrollMixin],
  components: {
    Loading,
    OrderItemsWoitemsSubList,
  },
  methods: {
    wheelItBetter(event, item) {
      item.requestedQuantity = this.scrollMixinEvent(
        event,
        item.requestedQuantity
      );
      this.$emit('update-order-item', item);
    },
    updateExtra(currentValue, item) {
      this.$emit('update-order-item', {
        ...item,
        requestedQuantity: currentValue,
      });
    },
    updateSupplier(currentValue, item) {
      this.$emit('update-order-item', {
        ...item,
        selectedSupplierIdPublic: currentValue,
      });
    },
    removeItem(item) {
      this.$emit('remove-order-item', item);
    },
    removeWorkOrderItem(item, woItemIdPublic) {
      this.$emit('remove-work-order-item', item, woItemIdPublic);
    },
    isAnyError() {
      let anyError = false;
      this.orderItemsList.forEach((x) => {
        if (
          x.quantityType == 'unitary' &&
          !Number.isInteger(Number(x.requestedQuantity))
        ) {
          anyError = true;
          x.errorRequested = true;
          x.anyError = true;
        } else if (x.requestedQuantity < 0) {
          anyError = true;
          x.errorMinimum = true;
          x.anyError = true;
        }
      });

      return anyError;
    },
    createOrders() {
      this.isLoading = true;

      if (this.isAnyError()) {
        this.isLoading = false;
      } else {
        OrdersRepository.actions
          .automaticCreation(
            this.orderItemsList.map((x) => {
              return {
                itemIdPublic: x.itemIdPublic,
                supplierIdPublic: x.selectedSupplierIdPublic,
                workOrderItemsSum: x.workOrderItemsSum,
                workOrderItems: x.workOrderItems,
                totalUnits: x.realOrderQuantity,
                orderQuantity: x.realOrderQuantity * x.orderUnitQuantity,
              };
            })
          )
          .then(() => {
            this.isLoading = false;
            this.$emit('refresh-data');
          })
          .catch((error) => {
            this.isLoading = false;
            if (error.response.status == 409) {
              this.$toast.warningToast(
                this.$t('errors.wasDesyncedTryAgainBulk')
              );
            } else {
              this.$toast.errorToast(this.$t('errors.errorLoading'));
            }
            this.$emit('refresh-data');
          });
      }
    },
  },
  computed: {
    orderItemsListComputed() {
      return this.orderItemsList.map((oi) => {
        let itemSupplier = oi.suppliersList.find(
          (x) => x.supplierIdPublic == oi.selectedSupplierIdPublic
        );

        if (itemSupplier != null) {
          oi.orderUnitQuantity = itemSupplier.orderUnitQuantity;
          oi.orderMinimumQuantity = itemSupplier.orderMinimumQuantity;
          oi.unitName = itemSupplier.unitName ?? '';
        } else {
          oi.orderUnitQuantity = 1;
          oi.orderMinimumQuantity = 0;
          oi.unitName = '';
        }

        if (oi.orderUnitQuantity <= 0) {
          oi.orderUnitQuantity = 1;
        }

        oi.totalQuantity = this.toFloat(
          Number(oi.requestedQuantity) + Number(oi.workOrderItemsSum)
        );

        let unitQuantity = Math.ceil(oi.totalQuantity / oi.orderUnitQuantity);

        oi.realOrderQuantity = Math.max(oi.orderMinimumQuantity, unitQuantity);

        return oi;
      });
    },
  },
};
</script>

<template>
  <b-container
    fluid
    style="
      margin-left: 12px;
      margin-right: 12px;
      background-color: #f8f8f8;
      border-radius: 5px;
    "
  >
    <b-row>
      <b-col cols="12">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#f1b44c"
          :width="70"
          :height="70"
          loader="dots"
          :is-full-page="false"
        >
        </loading>

        <b-container fluid>
          <b-row class="table-header">
            <b-col class="flex-vertical-align" cols="2">
              {{ $t('items.itemName') }}
            </b-col>
            <b-col class="text-center flex-vertical-align" cols="2">
              {{ $t('suppliers.supplier') }}
            </b-col>
            <b-col class="text-center flex-vertical-align" cols="2">
              {{ $t('orders.workOrdersRequests') }}
            </b-col>
            <b-col class="text-center flex-vertical-align" cols="2">
              {{ $t('general.extra') }}
            </b-col>
            <b-col class="text-center flex-vertical-align" cols="2">
              {{ $t('orders.realOrderValue') }}
            </b-col>
            <b-col class="text-center flex-vertical-align" cols="2">
              {{ $t('general.delete') }}
            </b-col>
          </b-row>

          <div v-for="item in orderItemsListComputed" :key="item.itemIdPublic">
            <b-row class="table-row">
              <b-col class="flex-vertical-align" cols="2">
                {{ item.itemName }}
              </b-col>
              <b-col class="text-center flex-vertical-align" cols="2">
                <b-form-select
                  :value="item.selectedSupplierIdPublic"
                  :options="item.suppliersList"
                  @input="updateSupplier($event, item)"
                  value-field="supplierIdPublic"
                  text-field="supplierName"
                ></b-form-select>
              </b-col>
              <b-col
                v-if="item.workOrderItemsSum > 0"
                v-b-toggle="'collapse-' + item.itemIdPublic"
                class="text-center flex-vertical-align clickable-text"
                cols="2"
              >
                {{ item.workOrderItemsSum }}
              </b-col>
              <b-col v-else class="text-center flex-vertical-align" cols="2">
                {{ item.workOrderItemsSum }}
              </b-col>
              <b-col class="text-center flex-vertical-align" cols="2">
                <b-input
                  :class="{
                    'is-invalid': item.anyError,
                  }"
                  type="number"
                  :step="item.quantityType == 'unitary' ? '1' : '0.00001'"
                  :value="item.requestedQuantity"
                  @wheel.prevent="wheelItBetter($event, item)"
                  @input="updateExtra($event, item)"
                />
                <div
                  v-if="item.errorRequested"
                  class="invalid-tooltip"
                  style="margin-left: 12px"
                >
                  <span>
                    {{ $t('errors.noDecimal') }}
                  </span>
                </div>
                <div
                  v-if="item.errorMinimum"
                  class="invalid-tooltip"
                  style="margin-left: 12px"
                >
                  <span>
                    {{ $t('errors.noDecimal') }}
                  </span>
                </div>
              </b-col>
              <b-col class="text-center flex-vertical-align" cols="2">
                {{ item.realOrderQuantity }}
                <template v-if="item.orderUnitQuantity != 1">
                  <template v-if="item.unitName != null">
                    {{ item.unitName.toLowerCase() }}
                  </template>
                  {{ $t('general.of') }}
                  {{ item.orderUnitQuantity }}
                </template>
              </b-col>

              <b-col class="text-center flex-vertical-align" cols="2">
                <i
                  class="fas fa-trash-alt text-danger pl-2 pr-2"
                  @click="removeItem(item)"
                  style="cursor: pointer; font-size: 1.3em"
                ></i>
              </b-col>
            </b-row>
            <OrderItemsWoitemsSubList
              :orderItem="item"
              @remove-work-order-item="removeWorkOrderItem"
            />
          </div>
        </b-container>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col
        cols="12"
        class="text-right align-bottom mt-auto"
        style="margin-bottom: 1rem"
      >
        <b-button @click="createOrders()" variant="primary">
          {{ $t('general.create') }}
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
.table-header {
  font-weight: bold;
  border-bottom: 1px solid rgb(209, 209, 209);
  padding: 10px 0 10px 0;
  margin-top: 10px;
}
.table-row {
  padding: 10px 0 10px 0;
}
</style>
